<template>
  <CompanyContainer />
</template>

<script lang="ts">
import Vue from "vue";
import CompanyContainer from "@/components/company/container/CompanyContainer.vue";

export default Vue.extend({
  components: {
    CompanyContainer,
  },
});
</script>
